import * as dataLayer from 'shared/utils/gtmDataLayer';
import { getAllExperiments } from 'libs/ab';

export default function* () {
  dataLayer.push({ event: 'ABExperimentsInit', ABExperiments: getAllExperiments() });
}
